import url from './url';



export default url(() => '/logical-test');
